import base from '../base';
import {
  getRequest,
  postJsonRequest,
  postRequest
} from '@/util/http';

const TRADING = {
  // 查询当前应用下的渠道
  queryPayChannel(params) {
    return getRequest(`${base.baseUrl}/payBill/query_pay_channel`, params);
  },
  // 查询渠道下的支付方式
  queryPayWay(params) {
    return getRequest(`${base.baseUrl}/payBill/query_pay_way`, params);
  },
  // 交易订单列表
  queryPayBill(params) {
    return postJsonRequest(`${base.baseUrl}/payBill/query_pay_bill`, params);
  },
  // 交易订单详情
  getBillById(params) {
    return postRequest(`${base.baseUrl}/payBill/getById`, params);
  },
  // 退款
  businessRefund(params) {
    return getRequest(`${base.baseUrl}/trade/business_refund`, params);
  },
};

export default TRADING;